module.exports = __webpack_public_path__ + "img/social-tg.ef2d5eb1.svg";